import _ from 'lodash';
import * as requests from '../request';

import { constructIdentifier } from '../functions';

/**
 * Hook that returns request function based on its name and given params, eg. getData(identifierName)
 * @param {String} func function name
 * @returns {[Function, null]} react-fetching-library request function or null if not enought data
 */
export default func => {
  if (!_.isNil(func)) {
    const functionSplitted = func.split('(');

    return requests[functionSplitted[0]](constructIdentifier(functionSplitted[1].replace(')', '')));
  }

  return null;
};
